import React from 'react';
import './social-buttons.css';

export const MICROSOFT_HINT = 'Finish signing in in the Microsoft window. Closed it? Click the button again.';

const PROVIDERS = [
	{ key: 'google', label: 'Continue with Google', logo: '/public/images/google-logo-NePEveMl.svg' },
	{ key: 'microsoft', label: 'Continue with Microsoft', logo: '/public/images/microsoft-logo-BUXxQnXH.svg' }
];

/**
 * SocialButtons — the "OR" rule, then our Google and Microsoft buttons at the
 * full form width. Only providers in `providers` render; with none, the whole
 * block (rule included) is omitted.
 *
 * @param {{
 *   providers: Array<'google'|'microsoft'>,
 *   onGoogle: () => void,
 *   onMicrosoft: () => void,
 *   isGoogleDisabled?: boolean,
 *   isMicrosoftDisabled?: boolean,
 *   showMicrosoftHint?: boolean,
 *   radius?: number
 * }} props `radius` (px) matches the surface's Sign In button; `showMicrosoftHint`
 *   while a Microsoft popup may be open.
 */
function SocialButtons({
	providers,
	onGoogle,
	onMicrosoft,
	isGoogleDisabled = false,
	isMicrosoftDisabled = false,
	showMicrosoftHint = false,
	radius = 8
}) {
	const visible = PROVIDERS.filter(p => providers.includes(p.key));
	if (visible.length === 0) return null;

	const handlers = { google: onGoogle, microsoft: onMicrosoft };
	const disabled = { google: isGoogleDisabled, microsoft: isMicrosoftDisabled };

	return (
		<div className="auth-social" style={{ '--auth-social-radius': `${radius}px` }}>
			<div className="auth-social__divider" aria-hidden="true">
				<span className="auth-social__rule" />
				<span className="auth-social__or">or</span>
				<span className="auth-social__rule" />
			</div>

			{visible.map(p => (
				<button
					key={p.key}
					type="button"
					className="auth-social-button"
					data-provider={p.key}
					disabled={disabled[p.key]}
					onClick={handlers[p.key]}
				>
					<img src={p.logo} alt="" aria-hidden="true" />
					<span>{p.label}</span>
				</button>
			))}

			{showMicrosoftHint && <p className="auth-social__hint">{MICROSOFT_HINT}</p>}
		</div>
	);
}

export default SocialButtons;
